import React from "react";
// @material-ui/core components

// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";

import Layout from "../../core/Layout";



export default function Credit() {
    return (
        <Layout>
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={8}>
                        Credit strana
                    </GridItem>
                </GridContainer>
            </div>
        </Layout>
    );
}
